import React from 'react'
import CustomRow from '../../reusable-components/CustomRow'
import { Col } from 'antd'
import { ContainerCard } from '../../reusable-components/AgiliteCards'
import PlanManagement from './PlanManagement'

const PlanWrapper = ({ isMonitoring, planType, planLabel }) => {
  return (
    <ContainerCard>
      <CustomRow>
        <Col span={24}>
          <PlanManagement isMonitoring={isMonitoring} planType={planType} planLabel={planLabel} />
        </Col>
      </CustomRow>
    </ContainerCard>
  )
}

export default PlanWrapper
